module.exports = __webpack_public_path__ + "img/timezone-switch.01f63579.svg";